import { styled } from 'styled-components'
export const Wrapper = styled.div`
  .url-container {
    width: 1200px;
  }
  .form-check-input:checked {
    background-color: var(--second-color) !important;
    border-color: var(--second-color);
  }
  .question {
    margin-left: 4px;
  }
  .question-drop svg {
    font-size: 0.7rem;
    margin-bottom: 0.2rem;
  }
`
